<template>
  <b-form-tags
      :value="value"
      @input="handleInputs"
      no-outer-focus
      class="mb-2"
      separator=" ,;"
      :tag-validator="tagValidator"
      :disabled="disabled"
      :state="state"
  >
    <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
      <b-input-group aria-controls="my-custom-tags-list">
        <b-form-input
            v-model="newTag"
            v-bind="inputAttrs"
            v-on="inputHandlers"
            :placeholder="placeHolder"
            class="form-control"/>
        <b-input-group-append>
          <b-button
              :disabled="disabled"
              style="border-radius:0 0.25em 0.25em 0 !important"
              @click="addTag()"
              variant="primary">{{ $t('components.product_tabs.add') }}
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <ul
          id="my-custom-tags-list"
          class="list-unstyled d-inline-flex flex-wrap mb-0"
          aria-live="polite"
          aria-atomic="false"
          aria-relevant="additions removals"
      >
        <!-- Always use the tag value as the :key, not the index! -->
        <!-- Otherwise screen readers will not read the tag
             additions and removals correctly -->
        <f-badge
            v-for="tag in tags"
            :key="tag"
            tag="li"
            class="mt-3 mr-1 d-flex"
            body-class="py-1 pr-2 text-nowrap"
            variant="primary"
            size="lg"
            flex
        >
          <span>{{ tag }}</span>
          <a @click="removeTag(tag)"
             href="javascript: void(0);">
            <i class="mdi mdi-close-circle-outline font-size-16 delete text-light"></i>
          </a>
        </f-badge>
      </ul>
    </template>
  </b-form-tags>
</template>

<script>
export default {
  name: "ProductTabs",
  props: {
    placeHolder: {
      default: '',
      type: String,
    },
    value: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
    regex: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      state: null,
      newTag: null
    }
  },
  watch: {
    newTag(val) {
      if (!val) {
        this.state = null
      }
    }
  },
  methods: {
    handleInputs(e) {
      this.newTag = ''
      this.$emit('input', e)
    },
    tagValidator(tag) {
      if (this.regex) {
        const filter = new RegExp(this.regex)
        this.state = !!tag.match(filter)
        return this.state
      }
      return true
    },
  }
}
</script>

<style scoped>
.delete {
  margin-left: 4px;
}
</style>